const {
  GIFTING_TREES,
  JOBS,
  SHOP,
  FAQ,
  INSTAGRAM,
  YOUTUBE,
  LINKEDIN,
  FACEBOOK,
  TREECARD,
  TWITTER,
} = require('../constants/urls');

const { DEFAULT_LOCALE, BLOG_LOCALES } = require('../constants/i18n');

const getBlogURL = (locale) => {
  const domain = BLOG_LOCALES.includes(locale) ? `${locale}.` : '';
  return `https://${domain}blog.ecosia.org`;
};

exports.getBlogURL = getBlogURL;

const getFinancialReportURL = (locale) => {
  const domain = BLOG_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
  return `https://ecosia.co/finreports${domain}`;
};

exports.getFinancialReportURL = getFinancialReportURL;

exports.getShareMenu = (text) => {
  const baseUrl = encodeURIComponent('https://info.ecosia.org?utm_source=stc');
  return [{
    label: 'Facebook',
    id: 'facebook',
    url: `https://www.facebook.com/sharer/sharer.php?u=${baseUrl}&t=${text}`,
  }, {
    label: 'Twitter',
    id: 'twitter',
    url: `https://www.twitter.com/share?url=${baseUrl}&text=${text}`,
  }, {
    label: 'Pinterest',
    id: 'pinterest',
    url: `http://pinterest.com/pin/create/link/?url=${baseUrl}`,
  }];
};

exports.getFooterMenu = (locale, settingsLink = false) => {
  const menu = [{
    url: getBlogURL(locale),
    key: 'blog',
  }, {
    url: TREECARD,
    key: 'treecard',
  }, {
    url: `${process.env.infoUrl}/privacy`,
    key: 'privacy',
  }];
  if (settingsLink) {
    menu.push({
      url: `${process.env.indexpageUrl}settings`,
      key: 'settings',
    });
  }
  menu.push({
    url: FAQ,
    key: 'faq',
  }, {
    url: `${process.env.infoUrl}/about#contact`,
    key: 'feedback',
  }, {
    url: `${process.env.infoUrl}/imprint`,
    key: 'imprint',
  });
  return menu;
};

exports.getFooterSitemap = () => [
  {
    url: `${process.env.infoUrl}/what`,
    key: 'how',
  },
  {
    url: `${process.env.infoUrl}/about`,
    key: 'about',
  },
  {
    url: `${process.env.infoUrl}/mobile`,
    key: 'mobileapp',
  },
  {
    url: `${process.env.infoUrl}/privacy`,
    key: 'privacy',
  },
  {
    url: `${process.env.indexpageUrl}settings`,
    key: 'settings',
  },
  {
    url: `${process.env.infoUrl}/about#contact`,
    key: 'feedback',
  },
];

exports.getFooterResources = (locale) => [
  {
    url: FAQ,
    key: 'faq',
  },
  {
    url: getFinancialReportURL(locale),
    key: 'financial',
  },
  {
    url: getBlogURL(locale),
    key: 'blog2',
  },
  {
    url: `${process.env.infoUrl}/press`,
    key: 'press',
  },
  {
    url: 'https://explore.ecosia.org/jobs',
    key: 'careers',
  },
  {
    url: TREECARD,
    key: 'treecard',
  },
];

exports.getSocialMenu = (withBlog = false, locale) => {
  const menu = [
    {
      label: 'facebook',
      url: FACEBOOK,
    },
    {
      label: 'twitter',
      url: TWITTER,
    },
    {
      label: 'youtube',
      url: YOUTUBE,
    },
    {
      label: 'instagram',
      url: INSTAGRAM,
    },
    {
      label: 'linkedin',
      url: LINKEDIN,
    },
  ];

  if (withBlog === true) {
    return menu.concat({
      label: 'blog',
      url: getBlogURL(locale),
    });
  }

  return menu;
};

exports.getMainMenu = (locale, settingsUrl) => [[
  {
    url: `${process.env.infoUrl}/what`,
    key: 'how',
  }, {
    url: `${process.env.infoUrl}/about`,
    key: 'about',
  }, {
    url: `${process.env.infoUrl}/mobile`,
    key: 'mobileapp',
  }, {
    url: `${process.env.infoUrl}/privacy`,
    key: 'privacy',
  },
], [
  {
    url: GIFTING_TREES,
    key: 'giftingtrees',
  },
  {
    url: SHOP,
    key: 'shop',
  }, {
    url: getBlogURL(locale),
    key: 'blog',
  }, {
    url: JOBS,
    key: 'careers',
  }, {
    url: FAQ,
    key: 'faq',
  },
], [
  {
    url: settingsUrl || '/settings',
    key: 'settings',
  },
]];
